import React, { HtmlHTMLAttributes } from "react";
import { cloneDeep } from "lodash";

import { ComponentItem } from "../../model/component";

import { RemoteComponent } from "./RemoteComponent";

type CompProps = HtmlHTMLAttributes<HTMLElement>;
export type RCType = (props?: CompProps) => React.ReactElement;
export type RCMapType = Record<string, RCType>;
export type RegistryOptions = ComponentItem[];

// 缓存组件
const components: RCMapType = {};
const editorConfigs: RCMapType = {};

/**
 * 根据名称获取对应的远程组件
 * @param name
 * @returns 远程组件
 */
export const getComponentByName = (name: string): RCType => {
  return components[name] || null;
};

/**
 * 根据名称获取对应的编辑器配置
 * @param name
 * @returns 编辑器配置
 */
export const getEditorConfigByName = (name: string): RCType | null => {
  return editorConfigs[name] ? cloneDeep(editorConfigs[name]) : null;
};

/**
 * 组件注册
 * @param urls
 * @returns {RCMapType}
 */
export function registryComponents(urls: RegistryOptions = []): void {
  const styles = [];
  const editorConfigUrls: Record<string, string> = {};
  const loadedComArr: string[] = [];

  for (let i = 0; i < urls.length; i++) {
    const c = urls[i];
    // const url = c.url;
    // 本地调试组件时使用
    const url =
      process.env.NODE_ENV === "development"
        ? c.url.replace("https://test-ec-mall.akulaku.com/growth-components", "http://127.0.0.1:5500/out")
        : c.url;
    const Component = (props?: CompProps): JSX.Element => (
      <RemoteComponent
        url={url}
        {...props}
        render={({ Component, err }): JSX.Element => {
          if (err) return <></>;
          if (!loadedComArr.includes(url)) {
            loadedComArr.push(url);
            // 第三方采集性能数据的api,是在用户点击或者是页面销毁的时候才收集到LCP数据,这样容易漏报很多数据,等组件加载完自动模拟一次点击事件,提前上报时机
            if (loadedComArr.length === urls.length) {
              setTimeout(() => {
                document.getElementsByTagName("body")[0] && document.getElementsByTagName("body")[0].click();
              }, 100);
            }
          }
          return <Component {...props} />;
        }}
      />
    );

    styles.push(url.slice().replace(/\.js/, ".css"));
    editorConfigUrls[c.name] = url.slice().replace(/[a-zA-Z]+\.js/, "editor.json");
    components[c.name] = Component;
  }
  createComponentStyles(styles);
}

/**
 * 批量注册组件样式。
 * @param urls
 */
function createComponentStyles(urls: Array<string> = []): void {
  const frag = document.createDocumentFragment();
  urls.forEach((url) => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = url;
    frag.appendChild(link);
  });
  frag.childElementCount > 0 && document.head.appendChild(frag);
}
